import * as React from 'react';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox/index';
import { InlineBlock, InlineParam } from '../markup';

export interface IOption<T> {
  title: string;
  value: T;
}

interface IButtonCheckboxListProps<T> {
  list: IOption<T>[];
  selected: T[];

  select(value: T): void;
  deselect(value: T): void;
}

export class ButtonCheckboxList<T> extends React.PureComponent<IButtonCheckboxListProps<T>> {
  public render() {
    return (
      <InlineBlock>
        {this.props.list.map(({ title, value }, index) => {
          const isSelected = this.props.selected.includes(value);
          const handleChange = isSelected ? this.props.deselect.bind(null, value) : this.props.select.bind(null, value);

          return (
            <InlineParam key={index}>
              <ButtonCheckbox value={isSelected} onValueChange={handleChange}>
                {title}
              </ButtonCheckbox>
            </InlineParam>
          );
        })}
      </InlineBlock>
    );
  }
}
